// extracted by mini-css-extract-plugin
export default {"main":"main--15A9Qe-","heading":"heading--2SidLBX","mainLeft":"mainLeft--3fx0DSN","mainRight":"mainRight--2SGwuyR"};